import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../components/navbar";
import bg4 from "../assect/images/1.jpg"

import {FiPhone, FiHexagon, FiMapPin,FiMail} from "../assect/icons/vander"
import Footer from "../components/footer";
export default function ContactUs(){
    return(
        <>
        <Navbar navClass="defaultscroll sticky" logolight={true} menuClass = "navigation-menu nav-left nav-light"/>
        <section className="bg-half-170 d-table w-100" style={{background: "linear-gradient(to right, #3494E6, #EC6EAD)", boxShadow: "0 4px 15px rgba(0,0,0,0.1)"}}>
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-12">
                        <div className="title-heading text-center">
                            <p className="text-white para-desc mx-auto mb-0 fw-semibold">Get in touch !</p>
                            <h5 className="heading fw-bold mb-0 sub-heading text-white title-dark" style={{fontSize: "2.5rem", textShadow: "2px 2px 4px rgba(0,0,0,0.2)"}}>Contact us</h5>
                        </div>
                    </div>
                </div>
                {/* <div className="position-middle-bottom">
                    <nav aria-label="breadcrumb" className="d-block">
                        <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                            <li className="breadcrumb-item"><Link to="/">Towntor</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Contact us</li>
                        </ul>
                    </nav>
                </div> */}
            </div>
        </section>
        <div className="position-relative">
            <div className="shape overflow-hidden text-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <section className="section pb-0">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="p-4 rounded-3 shadow">
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                const name = document.getElementById('name').value;
                                const email = document.getElementById('email').value;
                                const subject = document.getElementById('subject').value;
                                const comments = document.getElementById('comments').value;
                                
                                const message = `Halo Gondola Ancol%0A%0ANama: ${name}%0AEmail: ${email}%0ASubyek: ${subject}%0APesan: ${comments}`;
                                
                                window.open(`https://api.whatsapp.com/send?phone=6285281672907&text=${message}`, '_blank');
                            }}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Nama <span className="text-danger">*</span></label>
                                            <input name="name" id="name" type="text" className="form-control" placeholder="Nama :"/>
                                        </div>
                                    </div>
    
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Email <span className="text-danger">*</span></label>
                                            <input name="email" id="email" type="email" className="form-control" placeholder="Email :"/>
                                        </div> 
                                    </div>
    
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">Subyek</label>
                                            <input name="subject" id="subject" className="form-control" placeholder="Perihal :"/>
                                        </div>
                                    </div>
    
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">Pesan <span className="text-danger">*</span></label>
                                            <textarea name="comments" id="comments" rows="4" className="form-control" placeholder="Pesan :"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-grid">
                                            <button type="submit" id="submit" name="send" className="btn btn-primary">Kirim Pesan</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="container mt-100 mt-60">
                <div className="row g-4">
                    <div className="col-md-4">
                        <div className="position-relative features text-center mx-lg-4 px-md-1">
                            <div className="feature-icon position-relative overflow-hidden d-flex justify-content-center">
                                <FiHexagon className="hexagon"/>
                                <div className="position-absolute top-50 start-50 translate-middle">
                                    <FiPhone className="fea icon-m-md text-primary"/>
                                </div>
                            </div>
    
                            <div className="mt-4">
                                <h5 className="mb-3">Phone</h5>
                                <p className="text-muted">Start working with Towntor that can provide everything</p>
                                <Link to="tel:+152534-468-854" className="text-primary">+152 534-468-854</Link>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4">
                        <div className="position-relative features text-center mx-lg-4 px-md-1">
                            <div className="feature-icon position-relative overflow-hidden d-flex justify-content-center">
                                <FiHexagon className="hexagon"/>
                                <div className="position-absolute top-50 start-50 translate-middle">
                                    <FiMail className="fea icon-m-md text-primary"/>
                                </div>
                            </div>
    
                            <div className="mt-4">
                                <h5 className="mb-3">Email</h5>
                                <p className="text-muted">Start working with Towntor that can provide everything</p>
                                <Link to="mailto:contact@example.com" className="text-primary">contact@example.com</Link>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4">
                        <div className="position-relative features text-center mx-lg-4 px-md-1">
                            <div className="feature-icon position-relative overflow-hidden d-flex justify-content-center">
                               <FiHexagon className="hexagon"/>
                                <div className="position-absolute top-50 start-50 translate-middle">
                                    <FiMapPin className="fea icon-m-md text-primary"/>
                                </div>
                            </div>
    
                            <div className="mt-4">
                                <h5 className="mb-3">Location</h5>
                                <p className="text-muted">C/54 Northwest Freeway, Suite 558, <br/>Houston, USA 485</p>
                                <Link to="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39206.002432144705!2d-95.4973981212445!3d29.709510002925988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c16de81f3ca5%3A0xf43e0b60ae539ac9!2sGerald+D.+Hines+Waterwall+Park!5e0!3m2!1sen!2sin!4v1566305861440!5m2!1sen!2sin" className="lightbox text-primary" data-type="iframe" data-group="iframe" data-width="1024px" data-height="576px">View on Google map</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="container-fluid mt-100 mt-60">
                <div className="row">
                    <div className="col-12 p-0">
                        <div className="card map border-0">
                            <div className="card-body p-0">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3967.0383946589886!2d106.83867017402376!3d-6.125535660060365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e6a1e180888459f%3A0x89ede5a66264ef41!2sGondola%20Ancol%20Stasiun%20C!5e0!3m2!1sen!2sid!4v1702786839545!5m2!1sen!2sid" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" style={{border:"0" }} title="Gondola Ancol" allowFullScreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Footer/>
        </>
    )
}